import { createFileRoute } from '@tanstack/react-router';
import { validateCreateDraftTaskSearch } from '../../-publicSearch';

export const Route = createFileRoute('/app/draft-task/create')({
  validateSearch: validateCreateDraftTaskSearch,
});
